import React from 'react'

const ConsigeeDocs = ({ shipment }) => {

    if (shipment.consigneeDocuments && shipment.consigneeDocuments.length) {
        return (
            <div className="row mb-3 mt-3">
                <div className="col">
                    <span className="bold">Delivery Documents:</span><br />
                    {shipment.consigneeDocuments.map((document, index) => <a href={document.url} target="_blank" rel="noopener noreferrer " key={index}><span className='text-capitalize'>{document.name}</span></a>)}
                </div>
            </div>
        )
    } else { return null }
}

export default ConsigeeDocs
